// src/components/FundingNotifier.jsx
import { useEffect } from "react";
import { toast } from "react-toastify";
import api from "../api/api";

const STORAGE_KEY = "fund_notice_since";
const POLL_MS = 20000;

const naira = (n) => "₦" + Math.round(Number(n) || 0).toLocaleString("en-NG");

function readSince() {
  try {
    return localStorage.getItem(STORAGE_KEY) || "";
  } catch (e) {
    return "";
  }
}

function writeSince(value) {
  try {
    localStorage.setItem(STORAGE_KEY, value);
  } catch (e) {
    // ignore storage errors
  }
}

export default function FundingNotifier() {
  useEffect(() => {
    let cancelled = false;
    let failures = 0;

    const check = async () => {
      if (cancelled || failures >= 5 || document.hidden) return;
      if (!localStorage.getItem("accessToken")) return;

      try {
        const since = readSince();
        const res = await api.get("/wallet/funding-notices", {
          params: since ? { since } : {},
        });
        failures = 0;
        const data = res.data || {};
        const notices = Array.isArray(data.notices) ? data.notices : [];

        if (notices.length === 0) {
          if (data.serverTime) writeSince(data.serverTime);
          return;
        }

        writeSince(notices[notices.length - 1].createdAt);

        if (notices.length > 3) {
          toast.success("You received " + notices.length + " wallet credits. Check your history for details.", {
            autoClose: 8000,
          });
        } else {
          notices.forEach((n) => {
            if (n.kind === "bonus") {
              toast.success(
                "Bonus received: " + naira(n.amount) + " (" + n.percent + "% funding bonus) added to your wallet.",
                { autoClose: 9000 }
              );
            } else {
              toast.success(naira(n.amount) + " has been added to your wallet.", { autoClose: 8000 });
            }
          });
        }

        window.dispatchEvent(new Event("wallet-credited"));
      } catch (e) {
        failures += 1;
      }
    };

    check();
    const timer = setInterval(check, POLL_MS);
    const onVisible = () => {
      if (!document.hidden) check();
    };
    document.addEventListener("visibilitychange", onVisible);

    return () => {
      cancelled = true;
      clearInterval(timer);
      document.removeEventListener("visibilitychange", onVisible);
    };
  }, []);

  return null;
}